<div *ngIf="banner?.type === 'renewal'" class="renewal-banner">
  <span *ngIf="banner!.daysLeft! > 1">{{ 'subscription.bannerDaysLeftPlural' | translate: { daysLeft: banner!.daysLeft } }}</span>
  <span *ngIf="banner!.daysLeft === 1">{{ 'subscription.bannerDaysLeftSingular' | translate }}</span>
  <span *ngIf="banner!.daysLeft === 0">{{ 'subscription.bannerExpiresToday' | translate }}</span>
  <button *ngIf="!renewalRequestSent" class="upgrade-banner-btn"
          (click)="requestRenewal()" [disabled]="renewalRequestLoading">
    {{ renewalRequestLoading ? ('subscription.bannerContactSending' | translate) : ('subscription.bannerContactUs' | translate) }}
  </button>
  <span *ngIf="renewalRequestSent" class="upgrade-sent-msg">{{ 'subscription.bannerContactSent' | translate }}</span>
</div>
<div *ngIf="banner?.type === 'renewal_grace'" class="renewal-banner renewal-banner--overdue">
  <span>{{ 'subscription.bannerExpiredRenewNow' | translate }}</span>
  <button *ngIf="!renewalRequestSent" class="upgrade-banner-btn upgrade-banner-btn--red"
          (click)="requestRenewal()" [disabled]="renewalRequestLoading">
    {{ renewalRequestLoading ? ('subscription.bannerContactSending' | translate) : ('subscription.bannerContactUs' | translate) }}
  </button>
  <span *ngIf="renewalRequestSent" class="upgrade-sent-msg">{{ 'subscription.bannerContactSent' | translate }}</span>
</div>
<div *ngIf="banner?.type === 'trial'" class="trial-banner">
  <span *ngIf="banner!.daysLeft! > 1">{{ 'trial.bannerDaysLeftPlural' | translate: { daysLeft: banner!.daysLeft } }}</span>
  <span *ngIf="banner!.daysLeft === 1">{{ 'trial.bannerDaysLeftSingular' | translate: { daysLeft: 1 } }}</span>
  <span *ngIf="banner!.daysLeft === 0">{{ 'trial.bannerExpiresToday' | translate }}</span>
  <button *ngIf="!upgradeRequestSent" class="upgrade-banner-btn"
          (click)="requestUpgrade()" [disabled]="upgradeRequestLoading">
    {{ upgradeRequestLoading ? ('trial.bannerSending' | translate) : ('trial.bannerRequestUpgrade' | translate) }}
  </button>
  <span *ngIf="upgradeRequestSent" class="upgrade-sent-msg">{{ 'trial.bannerRequestSent' | translate }}</span>
</div>
<ul class="menu-list width100">
  <li><img [ngStyle]="{'width.px': logoWidth, 'height.px': logoHeight}" *ngIf="logo" [src]="logo" /></li>
  <li *ngFor="let item of menuItems" appAmfaAccess moduleName="{{ item.name }}" forceCheckLevel="MODULE">
    <!-- <a [routerLink]="item.href" routerLinkActive="active" class="nav-text">{{ item.label }}</a> -->
    <a *ngIf="!item.isExternal" routerLinkActive="active" class="nav-text" (click)="callImageCapture();navigateMe(item.href)">{{'menuLabels.'+
      item.label | translate}}</a>
    <a *ngIf="item.isExternal" class="nav-text" [href]="item.href" target="_blank" rel="noopener noreferrer">{{'menuLabels.'+
      item.label | translate}}</a>
  </li>
  <li class="user-logo">
    <span mat-icon-button aria-label="user">
      <span class="user-name">{{ userInfo }}</span>
      <!-- <mat-icon class="user-avtar">person_outline</mat-icon> -->
      <mat-icon class="user-expand" [matMenuTriggerFor]="menu">expand_more</mat-icon>
    </span>
  </li>
</ul>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="callImageCapture();logout()">{{'logout' | translate}}</button>
</mat-menu>